import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { BodyDialog, ImgLogo, Body, BoxActions, ColCentered, ButtoPayment, Title, SubTitle } from "./styles";
import ImgWit from "../../../../assets/img/witsoccer-logo.png";
import { Row, Col } from "react-bootstrap";
import FormInput from "components/core/FormInput";
import { Formik } from "formik";
import * as yup from "yup";
import FormTextarea from "../../../core/FormTextarea";
import { Creators as schollActions } from "store/ducks/school";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { phoneMask } from "../../../../helpers/maskHelpers";
import './modal.css';
const AlertPaym = withReactContent(Swal);

const ModalSchool = ({
  modalIsOpen,
  afterOpenModal,
  closeModal,
  customStyles,
  registerSchool,
  clearMessage,
  school,
  closeDialogShowForm
}) => {
  const initialValues = {
    name: "",
    email: "",
    cell: "",
    phone: "",
    text: "",
    message: ""
  };
  const validationSchema = yup.object().shape({
    name: yup.string().required("Nome é um campo obrigátorio"),
    email: yup.string().email("O e-mail não é válido").required("Email é um campo obrigátorio"),
    cell: yup.string().required("Celular é um campo obrigátorio"),
    phone: yup.string().required("Telefone é um campo obrigátorio"),
    message: yup.string().required("Messagem é um campo obrigátorio")
  });

  const [closeDialog, setDialog] = useState(false);

  useEffect(() => {
    if (school.message) {
      setDialog(true)
      AlertPaym.fire({
        title: school.message,
        icon: "success",
        confirmButtonText: "OK"
      }).then(value => {
        closeDialogShowForm();
        clearMessage();
      });
    }
  }, [school]);

  return (
    <Modal
      isOpen={modalIsOpen && !closeDialog}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      className="custom-dialog"
      style={{
        overlay: {
          backgroundColor: "#000"
        }
      }}
    >
      <BodyDialog>
        <Body>
          <ImgLogo src={ImgWit} />
          <Title>
            Escolas de Futebol – Queremos ser seu parceiro. Faça seu cadastro e
            conheça todos os benefícios de ser um associado Wit Soccer
          </Title>
          <SubTitle>Preencha os campos abaixo e aguarde o contato da nossa equipe</SubTitle>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={values => {
              registerSchool(values);
            }}
          >
            {props => {
              const {
                values,
                touched,
                errors,
                isSubmitting,
                handleChange,
                setFieldValue,
                handleBlur,
                handleSubmit
              } = props;
              return (
                <>
                  <Row>
                    <Col md="12">
                      <FormInput
                        type="text"
                        id="name"
                        name="name"
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isError={errors.name && touched.name}
                        error={errors.name}
                      >
                        Nome completo:
                      </FormInput>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormInput
                        type="text"
                        id="name"
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isError={errors.email && touched.email}
                        error={errors.email}
                      >
                        Email:
                      </FormInput>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <FormInput
                        type="text"
                        id="name"
                        name="cell"
                        value={phoneMask(values.cell)}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isError={errors.cell && touched.cell}
                        error={errors.cell}
                      >
                        Celular:
                      </FormInput>
                    </Col>
                    <Col md="6">
                      <FormInput
                        type="text"
                        id="phone"
                        name="phone"
                        value={phoneMask(values.phone)}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isError={errors.phone && touched.phone}
                        error={errors.phone}
                      >
                        Telefone:
                      </FormInput>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormTextarea
                        type="text"
                        id="message"
                        name="message"
                        value={values.message}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isError={errors.message && touched.message}
                        error={errors.message}
                      >
                        Mensagem:
                      </FormTextarea>
                    </Col>
                  </Row>
                  <BoxActions>
                  <Row>
                      <ColCentered sm="12" md="6">
                        <ButtoPayment
                          onClick={() => {
                            setDialog(true);
                            closeDialogShowForm();
                          }}
                          >
                          <p>Cancelar</p>
                        </ButtoPayment>
                      </ColCentered>
                      <ColCentered sm="12" md="6">
                        <ButtoPayment
                          onClick={handleSubmit}
                          type="submit"
                          selected={true}
                          >
                          <p>Enviar</p>
                        </ButtoPayment>
                      </ColCentered>
                  </Row>
                  </BoxActions>
                </>
              );
            }}
          </Formik>
        </Body>
      </BodyDialog>
    </Modal>
  );
};
const mapDispatchToProps = dispatch => ({
  registerSchool: payload =>
    dispatch(schollActions.schoolRegisterRequest(payload)),
  clearMessage: () => dispatch(schollActions.schoolClearMessage())
});
const mapStateToProps = state => ({
  school: state.school
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalSchool);
